import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { insurancePlanNamesDataSource } from 'infrastructure/data-sources/insurance-plan-name';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IInsurancePlanNameItem } from 'infrastructure/data-sources/insurance-plan-name';

type Options = IBaseSelectBoxOption<
  IInsurancePlanNameItem['id'],
  IInsurancePlanNameItem
>[];

interface IInsurancePlanNameSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const InsurancePlanNameSelectBox: React.FC<
  IInsurancePlanNameSelectBoxProps
> = ({ ...props }) => {
  const dataSource = useMemo(() => insurancePlanNamesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default InsurancePlanNameSelectBox;
